export default "__VITE_ASSET__BD2KRgrc__"